import { render, staticRenderFns } from "./DepartmentFactsContactsRow.vue?vue&type=template&id=3a80e5af&scoped=true"
import script from "./DepartmentFactsContactsRow.vue?vue&type=script&lang=js"
export * from "./DepartmentFactsContactsRow.vue?vue&type=script&lang=js"
import style0 from "./DepartmentFactsContactsRow.vue?vue&type=style&index=0&id=3a80e5af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a80e5af",
  null
  
)

export default component.exports